import { FormHelper } from './../../../../../base/shared/form-helper';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { ExportInterfaceConfigurationDetailsRESTDTO } from 'src/app/base/models/models.swagger.generated';
import { ConfigurationFormCoordinatorService } from '../configuration-form-coordinator.service';
import { startWith } from 'rxjs/operators';
import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { passwordValidation } from 'src/app/directives/password-validation.directive';
import { PasswordGenerator } from 'src/app/base/shared/password-generator';
import { TranslateModule } from '@ngx-translate/core';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { NgClass } from '@angular/common';
import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';

@Component({
    selector: 'app-configuration-form-rest',
    templateUrl: './configuration-form-rest.component.html',
    styleUrls: ['./configuration-form-rest.component.scss'],
    imports: [
    ReactiveFormsModule,
    YesNoGroupButtonComponent,
    AppErrorMessagesComponent,
    NgClass,
    NumericTextBoxModule,
    TranslateModule
]
})
export class ConfigurationFormRestComponent implements OnInit {


  @Input() public data: ExportInterfaceConfigurationDetailsRESTDTO;

  public get configurationFormREST(): UntypedFormGroup {
    return this.configurationFormService.configurationFormREST;
  };

  constructor(private configurationFormService: ConfigurationFormCoordinatorService) {
  }

  ngOnInit() {
    this.configurationFormREST.get('isBearerToken').valueChanges
      .pipe(
        startWith(this.configurationFormREST.get('isBearerToken').value),
      )
      .subscribe(isBearerToken => {
        if (isBearerToken) {
          this.configurationFormREST.get('clientId').setValidators([Validators.required]);
          this.configurationFormREST.get('apiFixKey').setValidators([]);
          this.configurationFormREST.get('apiFixValue').setValidators([]);
          this.configurationFormREST.get('clientSecret').setValidators([Validators.required, CustomValidatorsFactory.createNoWhiteSpacesAllowed(), passwordValidation()]);
          this.configurationFormREST.get('refreshTokenLifetime').setValidators([Validators.required]);
        } else {
          this.configurationFormREST.get('clientId').setValidators([]);
          this.configurationFormREST.get('apiFixKey').setValidators([Validators.required]);
          this.configurationFormREST.get('apiFixValue').setValidators([Validators.required, CustomValidatorsFactory.createNoWhiteSpacesAllowed(), passwordValidation()]);
          this.configurationFormREST.get('clientSecret').setValidators([]);
          this.configurationFormREST.get('refreshTokenLifetime').setValidators([]);
          this.configurationFormREST.get('refreshTokenLifetime').setValue(0);
        }
        this.configurationFormREST.get('clientId').updateValueAndValidity();
        this.configurationFormREST.get('apiFixKey').updateValueAndValidity();
        this.configurationFormREST.get('apiFixValue').updateValueAndValidity();
        this.configurationFormREST.get('clientSecret').updateValueAndValidity();
        this.configurationFormREST.get('refreshTokenLifetime').updateValueAndValidity();
        this.configurationFormREST.updateValueAndValidity();
      })
  }

  public hasError(control: AbstractControl) {
    return FormHelper.hasErrorStatusToShow(control);
  }

  public generatePassword(): string {
    return PasswordGenerator.generatePassword();
  }

}
